/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingMetrics {
    getFixupPrototypeFunction() { return BillingMetrics.fixupPrototype; }

    static newInstance(model: Partial<BillingMetrics>): BillingMetrics {
        let obj = Object.assign(new BillingMetrics(), model);
        BillingMetrics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingMetrics>): BillingMetrics {
        if (!model) return null;
        return BillingMetrics.newInstance(<BillingMetrics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingMetrics) {
        if (!obj) return;

        models.BillingMetrics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingMetrics): boolean {
        Object.setPrototypeOf(obj, BillingMetrics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_on === "string") {
            this.created_on = new Date(<string><any>this.created_on);
        }
        if (typeof this.updated_on === "string") {
            this.updated_on = new Date(<string><any>this.updated_on);
        }
    }

    /**
     * The Sys ID of the metric
     */
    sys_id: string;

    /**
     * Specifies the source metrics. Only system metrics can have an empty source and cannot be removed.
     */
    source_sys_id: string;

    /**
     * Created on
     */
    created_on: Date;

    /**
     * Username who created the Billing Metrics.
     */
    created_by: string;

    /**
     * Updated on
     */
    updated_on: Date;

    /**
     * Username who updated the Billing Metrics.
     */
    updated_by: string;

    /**
     * Name of the billing metrics
     */
    name: string;

    /**
     * Types of Billing Metric.
     */
    billing_metric_type: models.BillingMetricType;

    /**
     * Categories of Billing Metric.
     */
    category: models.BillingMetricCategory;

}
